// @flow

import {useIntervalEffect} from '@react-hookz/web';
import {useDispatch, useSelector} from 'react-redux';

import {getToken} from 'redux/uiState/layout/booking/reducer';
import {getBookStatus} from 'redux/v1/bookStatus/actions';
import {hasError, isBooked, isInProgress} from 'redux/v1/bookStatus/reducer';

type Status = {
  booked: boolean,
  bookingInProgress: boolean,
  requestFailed: boolean,
};

export const useBookStatus = (journeyId: number): Status => {
  const dispatch = useDispatch();
  const token = useSelector(getToken);
  const isBookingInProgress = useSelector(isInProgress);
  const isJourneyBooked = useSelector(isBooked);
  const hasRequestError = useSelector(hasError);

  useIntervalEffect(() => {
    dispatch(getBookStatus(journeyId, token));
  }, 15_000);

  return {
    bookingInProgress: isBookingInProgress,
    booked: isJourneyBooked,
    requestFailed: hasRequestError,
  };
};
